import { MdDeleteForever } from 'react-icons/md';
import { OrderIcon } from '../../../../../../../../assets/svg/order';
import { Collapse } from '../../../../../../../../components/collapse/collapse';
import { IconButton } from '../../../../../../../../components/icon-button/icon-button';
import { Modal, ModalProps } from '../../../../../../../../components/modal/modal';
import { DeleteModal } from '../../../../../../../../features/delete-modal/delete-modal';
import { EditableLabel } from '../../../../../../../../features/editable-label/editable-label';
import { HasAccess, HasAccessProps } from '../../../../../../../../features/has-access/has-access';
import { SortableItem } from '../../../../../../../../features/sorter/sortable-item';
import { Sorter } from '../../../../../../../../features/sorter/sorter';
import { useManagerStore } from '../../../../../../../../store/use-manager-store';
import { MenuInformerCreateUnit } from '../menu-informer-create-unit';
import s from './menu-informer-create-sections-modal.module.css';
import { useMenuInformerCreateSectionsModal } from './use-menu-informer-create-sections-modal';

export const MenuInformerCreateSectionsModal = (props: ModalProps) => {
  const {
    handleCreate,
    handleUpdate,
    isLoading,
    sections,
    t,
    getLocale,
    setSectionListOrder,
    addQueryParams,
    deleteSection,
    language,
  } = useMenuInformerCreateSectionsModal();

  const { hasAccess } = useManagerStore();
  const isNotAllowed = !hasAccess('menu', ['write']);
  const hasAccessProps: HasAccessProps = { service: 'menu', permissions: ['write'] };

  return (
    <Modal {...props} className={s.feature} title={t('Разделы')} withLang>
      <HasAccess {...hasAccessProps}>
        <MenuInformerCreateUnit
          placeholder={t('Название раздела')}
          isLoading={isLoading}
          name="createSectionName"
          onConfirm={handleCreate}
          data-testid="create-unit"
        />
      </HasAccess>

      {!!sections.length && (
        <Sorter
          itemIds={sections.map((item) => item.id)}
          onSort={(e) => setSectionListOrder(e.map(Number))}
          isDisabled={isNotAllowed}
        >
          <ul className={s.sections}>
            {sections.map((section, index) => {
              const categories = section.categories || [];

              return (
                <SortableItem
                  key={section.id}
                  isDisabled={isNotAllowed}
                  sortableArgs={{
                    id: section.id,
                    data: {
                      index,
                    },
                  }}
                  withSortIcon={false}
                >
                  <Collapse
                    id={`section-${index}`}
                    key={section.id}
                    motionKey={section.id}
                    headerClassName={s.headerWrapper}
                    header={
                      <div className={s.header}>
                        <HasAccess {...hasAccessProps}>
                          <IconButton variant="ghost">
                            <OrderIcon />
                          </IconButton>
                        </HasAccess>

                        <EditableLabel
                          value={getLocale(section.name, language)}
                          onConfirm={async (e) =>
                            handleUpdate({ ...section, name: { ...section.name, [language]: e } })
                          }
                          name="editSectionName"
                          data-testid={`section-name-${index}`}
                          isDisabled={isNotAllowed}
                        />

                        <HasAccess {...hasAccessProps}>
                          <IconButton
                            tooltip={t('Удалить')}
                            variant="secondary"
                            size="sm"
                            data-testid={`section-delete-${index}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              addQueryParams({
                                deleteId: section.id.toString(),
                                deleteName: getLocale(section.name, language),
                              });
                            }}
                          >
                            <MdDeleteForever />
                          </IconButton>
                        </HasAccess>
                      </div>
                    }
                  >
                    <ul className={s.categories}>
                      {categories.map(({ id, name }) => {
                        const categoryId = String(id);
                        const categoryName = getLocale(name, language);

                        return (
                          <li key={categoryId} className={s.category}>
                            {categoryName}
                          </li>
                        );
                      })}
                    </ul>
                  </Collapse>
                </SortableItem>
              );
            })}
          </ul>
        </Sorter>
      )}
      <DeleteModal onSubmit={deleteSection} />
    </Modal>
  );
};
